import {
    Button,
    Container,
    Form,
    FormGroup,
    Input,
    Segment,
    SegmentContent,
    SegmentHeader,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, useForm, usePage } from '@inertiajs/react';
import { useMemo } from 'react';

const FIELDS = [
    { name: 'organisation', label: 'Organisatie', required: true },
    { name: 'office', label: 'Kantoor' },
    { name: 'gender', label: 'Geslacht', required: true },
    { name: 'first_name', label: 'Voornaam', required: true },
    { name: 'last_name', label: 'Achternaam', required: true },
    { name: 'telephone_number', label: 'Telefoonnummer', required: true },
    { name: 'mobile_number', label: 'Mobiel nummer' },
    { name: 'email', label: 'E-mailadres', type: 'email', required: true },
    { name: 'zipcode', label: 'Postcode' },
    { name: 'postbus', label: 'Postbus' },
    { name: 'city', label: 'Plaats' },
];

const CreateOrUpdateView = () => {
    const { office_contact } = usePage().props;
    const { data, setData, errors, post, patch, processing } = useForm(
        FIELDS.reduce(
            (values, field) => ({
                ...values,
                [field.name]: office_contact?.[field.name] || '',
            }),
            {}
        )
    );

    const handleSubmit = () => {
        if (!office_contact?.id) {
            post('/office-contacts');

            return;
        }

        patch(`/office-contacts/${office_contact.id}`);
    };

    const title = useMemo(
        () =>
            office_contact?.id
                ? 'Wijzig contactpersoon'
                : 'Nieuwe contactpersoon',
        [office_contact]
    );

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader header={title}>
                        <Button as={Link} href='/office-contacts'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <FormGroup>
                            {FIELDS.map(field => (
                                <Input
                                    key={field.name}
                                    label={field.label}
                                    type={field.type || 'text'}
                                    required={field.required}
                                    value={data?.[field.name] || ''}
                                    onChange={event =>
                                        setData(
                                            field.name,
                                            event?.target?.value
                                        )
                                    }
                                    error={errors?.[field.name]}
                                />
                            ))}
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default CreateOrUpdateView;
